import { render, staticRenderFns } from "./Admit.vue?vue&type=template&id=6ca08861&"
import script from "./Admit.vue?vue&type=script&lang=js&"
export * from "./Admit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports